// Neverthirst Theme — Global JS
// Cart count update after add-to-cart form submissions
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;
  // Let Shopify handle the redirect; count refreshes on next page load
});
